const Env = {
	PROD: "PROD",
	PREPROD: "PREPROD",
	DEV: "DEV",
} as const;

type Env = (typeof Env)[keyof typeof Env];

type EnvVariable = {
	HOST_PREFIX: string;
	GOOGLE_TAG_MANAGER_TAG_ID: string;
};

export const getEnv = (): Env => {
	const prodRegExp = /^tracking.bus.blablacar.com/i;
	if (prodRegExp.test(window.location.host)) return Env.PROD;

	const preProdRegExp = /^tracking-bus.preprod-1.blbl.cr/i;
	if (preProdRegExp.test(window.location.host)) return Env.PREPROD;

	return Env.DEV;
};

export const getEnvVariables = (): EnvVariable => {
	if (getEnv() === Env.PROD) {
		return {
			HOST_PREFIX: window.location.origin,
			GOOGLE_TAG_MANAGER_TAG_ID: "G-5N09NPQFRH",
		};
	}

	if (getEnv() === Env.PREPROD) {
		return {
			HOST_PREFIX: window.location.origin,
			GOOGLE_TAG_MANAGER_TAG_ID: "",
		};
	}

	return {
		HOST_PREFIX: import.meta.env.PUBLIC_REACT_APP_API_ORIGIN || "http://localhost:8086",
		GOOGLE_TAG_MANAGER_TAG_ID: "",
	};
};
